

import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ads-file-upload',
  templateUrl: './basic-file-upload.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: FileComponent, multi: true },
  ]
})
export class FileComponent implements ControlValueAccessor {
  public value: any;
  private onChange: (value: any) => void;
  public onTouched: () => void;
  @Input() name: string = 'file';
  @Input() disabled: boolean = false;
  @Input('isUploadButton') isuploadButton: boolean = false;
  @Input('autoUpload') autoUpload: boolean = false;
  @Input() accept: string = '';
  @Input() acceptTypes: string = '';
  @Input() fileLimit: string = '';
  @Input() fileSize: string = '';
  @Input() required: string = '';
  @Input("multiple") multiple: boolean = false;
  @Output() uploadEvent: EventEmitter<any> = new EventEmitter<any>();
  file_errorsList: any[] = [];
  public filechange(e) {
    this.onChange(e.target.files);
    this.onTouched();
    this.file_errorsList = [];
    this.value = e.target.files;
    //checking size
    if (parseInt(this.fileSize) > 0) {
      for (var i = 0; i < e.target.files.length; i++) {
        if (e.target.files[i].size > this.fileSize) {
          this.file_errorsList.push({ 'name': e.target.files[i].name + ` :  Invalid file size `, 'message': `maximum upload size is ` + this.fileSize });
        }
      }
    }
    //checking number of files
    if (parseInt(this.fileLimit) > 0) {
      if (e.target.files.length > this.fileLimit) {
        this.file_errorsList.push({ 'name': `Maximum number of files exceeded :`, 'message': `limit is ` + this.fileLimit + ` at most` });
      }
    }
    //checking acceptTypes
    if (this.acceptTypes != '') {
      let acceptTypes = (this.acceptTypes).replace(/\s*,\s*/g, ",").split(',');
      for (var i = 0; i < e.target.files.length; i++) {
        if (acceptTypes.indexOf(e.target.files[i].name.slice(e.target.files[i].name.lastIndexOf(".")).toLowerCase()) == -1) {
          this.file_errorsList.push({ 'name': e.target.files[i].name + ` : Invalid file type,`, 'message': `allowed file types:` + this.acceptTypes });
        }
      }
    }
    if (this.file_errorsList.length > 0)
      this.value = null;
    if (this.autoUpload) {
      if (this.file_errorsList.length == 0)
        this.uploadEvent.emit(e);
    }

  }

  file_remove(index) {
    this.file_errorsList.splice(index, 1);
  }

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onUpload(e) {
    this.uploadEvent.emit(e);
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
